import React, { useEffect } from "react";

// Components
import { HeaderWrapper, Row, OrganizationName, Header } from "./OrganizationCarriersPage.styles";
import { Button, Alert } from "antd";
import { PlusOutlined } from "@ant-design/icons";

// Helpers
import { get } from "lodash-es";

// Hooks
import { useParams, useHistory } from "react-router";
import { useCarriers } from "../../../../hooks/api/fulfillment/carriers";
import CarriersTable from "./CarriersTable";
import { useOrganizationContext } from "contextProviders/organization/OrganizationProvider";

const OrganizationCarriersPage = (): React.ReactElement => {
  const params = useParams();
  const history = useHistory();
  const organizationID = get(params, "organization_id", "");
  const { data: organization } = useOrganizationContext();
  const { carriers, fetchCarriers } = useCarriers();

  useEffect(() => {
    window.scrollTo(0, 0);
    if (organization?.id) {
      fetchCarriers(organization?.id);
    }
    //eslint-disable-next-line
  }, [organization]);

  return (
    <div className="page-container">
      {carriers.error && <Alert message={carriers.error} type="error" banner />}

      <HeaderWrapper>
        <Row padding="0 0 16px" spaceBetween>
          <OrganizationName
            onClick={() => {
              history.push(`/organizations/${organizationID}`);
            }}
          >
            {get(organization, "name", "-")}
          </OrganizationName>
          <Button
            id="create-user-button"
            className="add-user-btn"
            icon={<PlusOutlined />}
            onClick={() => history.push(`/organizations/${organizationID}/carriers/create`)}
          >
            Create Carrier
          </Button>
        </Row>
        <Header>CARRIERS</Header>
      </HeaderWrapper>

      <CarriersTable loading={carriers.loading} data={carriers.data} organizationID={organization?.id} />
    </div>
  );
};

export default OrganizationCarriersPage;
